"use strict";
(globalThis["webpackChunkweb"] = globalThis["webpackChunkweb"] || []).push([[7041],{

/***/ 40261:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Sz: () => (/* binding */ OPTION_LIST_SIZE),
/* harmony export */   YV: () => (/* binding */ KEY_STRINGS),
/* harmony export */   d0: () => (/* binding */ STATE_CHANGE_TYPES)
/* harmony export */ });
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var STATE_CHANGE_TYPES = {
  click: 'click',
  moveUp: 'moveUp',
  moveDown: 'moveDown',
  mouseEnter: 'mouseEnter',
  mouseLeave: 'mouseLeave',
  focus: 'focus',
  reset: 'reset',
  character: 'character',
  enter: 'enter'
};
var KEY_STRINGS = {
  ArrowUp: 'ArrowUp',
  ArrowDown: 'ArrowDown',
  ArrowLeft: 'ArrowLeft',
  ArrowRight: 'ArrowRight',
  Enter: 'Enter',
  Space: ' ',
  Escape: 'Escape',
  Backspace: 'Backspace',
  Home: 'Home',
  End: 'End'
};
var OPTION_LIST_SIZE = {
  default: 'default',
  compact: 'compact'
};

/***/ }),

/***/ 72935:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $: () => (/* binding */ NestedMenuContext),
/* harmony export */   Z: () => (/* binding */ NestedMenus)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

var NestedMenuContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({
  addMenuToNesting: function addMenuToNesting() {},
  removeMenuFromNesting: function removeMenuFromNesting() {},
  getParentMenu: function getParentMenu() {},
  getChildMenu: function getChildMenu() {},
  mountRef: {
    current: null
  }
});

function isSame(a, b) {
  if (!a || !b) {
    return false;
  }

  return a.isSameNode(b);
}

var NestedMenus = /*#__PURE__*/function (_React$Component) {
  _inherits(NestedMenus, _React$Component);

  var _super = _createSuper(NestedMenus);

  function NestedMenus() {
    var _this;

    _classCallCheck(this, NestedMenus);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      menus: []
    });

    _defineProperty(_assertThisInitialized(_this), "mountRef", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createRef());

    _defineProperty(_assertThisInitialized(_this), "addMenuToNesting", function (ref) {
      // check offsetHeight to determine if component is visible in the dom (0 means hidden)
      // we need to do this so that when we renderAll, the hidden seo-only child-menus don't
      // register themselves which would break the nesting logic
      if (ref.current && ref.current.offsetHeight) {
        _this.setState(function (state) {
          return {
            menus: [].concat(_toConsumableArray(state.menus), [ref])
          };
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "removeMenuFromNesting", function (ref) {
      _this.setState(function (state) {
        var nextMenus = state.menus.filter(function (r) {
          return r.current;
        }).filter(function (r) {
          return !isSame(r.current, ref.current);
        });
        return {
          menus: nextMenus
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "findMenuIndexByRef", function (ref) {
      return _this.state.menus.findIndex(function (r) {
        return isSame(r.current, ref.current);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getParentMenu", function (ref) {
      var index = _this.findMenuIndexByRef(ref) - 1;
      return _this.state.menus[index];
    });

    _defineProperty(_assertThisInitialized(_this), "getChildMenu", function (ref) {
      var index = _this.findMenuIndexByRef(ref) + 1;
      return _this.state.menus[index];
    });

    return _this;
  }

  _createClass(NestedMenus, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(NestedMenuContext.Provider, {
        value: {
          addMenuToNesting: this.addMenuToNesting,
          removeMenuFromNesting: this.removeMenuFromNesting,
          getParentMenu: this.getParentMenu,
          getChildMenu: this.getChildMenu,
          mountRef: this.mountRef
        }
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, this.props.children, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
        ref: this.mountRef
      })));
    }
  }]);

  return NestedMenus;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);



/***/ }),

/***/ 54274:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ StatefulMenu)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(30242);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/locale/index.js + 13 modules
var locale = __webpack_require__(1785);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/menu/styled-components.js
var styled_components = __webpack_require__(81833);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/helpers/overrides.js
var helpers_overrides = __webpack_require__(72221);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/menu/constants.js
var constants = __webpack_require__(40261);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/menu/nested-menus.js
var nested_menus = __webpack_require__(72935);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/popover/popover.js + 1 modules
var popover = __webpack_require__(2493);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/menu/maybe-child-menu.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/




function MaybeChildMenu(props) {
  if (!props.getChildMenu) {
    return props.children;
  }

  var ChildMenu = props.getChildMenu(props.item);

  if (!ChildMenu) {
    return props.children;
  }

  var _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides;

  var _getOverrides = (0,helpers_overrides/* getOverrides */.jb)(overrides.ChildMenuPopover, popover/* default */.Z),
      _getOverrides2 = _slicedToArray(_getOverrides, 2),
      PopoverOverride = _getOverrides2[0],
      popoverProps = _getOverrides2[1];

  return /*#__PURE__*/react.createElement(nested_menus/* NestedMenuContext */.$.Consumer, null, function (ctx) {
    return /*#__PURE__*/react.createElement(PopoverOverride, _extends({
      focusLock: false,
      isOpen: props.isOpen,
      renderAll: props.renderAll,
      content: ChildMenu,
      ignoreBoundary: true,
      mountNode: ctx.mountRef.current ? ctx.mountRef.current : undefined,
      onClick: props.onClick,
      onMouseEnterDelay: 30,
      onMouseLeaveDelay: 30,
      onEsc: props.resetParentMenu,
      placement: "rightTop"
    }, popoverProps, {
      overrides: (0,helpers_overrides/* mergeOverrides */.aO)({
        Body: {
          props: {
            // Adds mouseleave to popover body so that child menu closes when user mouses out.
            onMouseLeave: props.resetParentMenu,
            // Trap tabbing when focused on a child menu. Popover mounts the element at the end of
            // the html body by default. If a user was to tab to the next element it would navigate
            // to elements not within the immediate area surrounding the menu.
            onKeyDown: function onKeyDown(e) {
              if (e.keyCode === 9) {
                e.preventDefault();
              }
            }
          }
        }
      }, // $FlowFixMe - getOverrides' return type for props is {}
      popoverProps.overrides)
    }), props.children);
  });
}
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/menu/option-list.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function option_list_extends() { option_list_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return option_list_extends.apply(this, arguments); }

function option_list_slicedToArray(arr, i) { return option_list_arrayWithHoles(arr) || option_list_iterableToArrayLimit(arr, i) || option_list_unsupportedIterableToArray(arr, i) || option_list_nonIterableRest(); }

function option_list_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function option_list_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return option_list_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return option_list_arrayLikeToArray(o, minLen); }

function option_list_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function option_list_iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function option_list_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/







function OptionList(props, ref) {
  var getChildMenu = props.getChildMenu,
      _props$getItemLabel = props.getItemLabel,
      getItemLabel = _props$getItemLabel === void 0 ? function (item) {
    return item ? item.label : '';
  } : _props$getItemLabel,
      item = props.item,
      _props$onClick = props.onClick,
      onClick = _props$onClick === void 0 ? function () {} : _props$onClick,
      _props$onMouseEnter = props.onMouseEnter,
      onMouseEnter = _props$onMouseEnter === void 0 ? function () {} : _props$onMouseEnter,
      _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      _props$renderHrefAsAn = props.renderHrefAsAnchor,
      renderHrefAsAnchor = _props$renderHrefAsAn === void 0 ? true : _props$renderHrefAsAn,
      _props$resetMenu = props.resetMenu,
      resetMenu = _props$resetMenu === void 0 ? function () {} : _props$resetMenu,
      _props$size = props.size,
      size = _props$size === void 0 ? constants/* OPTION_LIST_SIZE */.Sz.default : _props$size,
      $isHighlighted = props.$isHighlighted,
      renderAll = props.renderAll,
      restProps = _objectWithoutProperties(props, ["getChildMenu", "getItemLabel", "item", "onClick", "onMouseEnter", "overrides", "renderHrefAsAnchor", "resetMenu", "size", "$isHighlighted", "renderAll"]);

  var _getOverrides = (0,helpers_overrides/* getOverrides */.jb)(overrides.ListItem, styled_components/* StyledListItem */.oH),
      _getOverrides2 = option_list_slicedToArray(_getOverrides, 2),
      ListItem = _getOverrides2[0],
      listItemProps = _getOverrides2[1];

  var _getOverrides3 = (0,helpers_overrides/* getOverrides */.jb)(overrides.ListItemAnchor, styled_components/* StyledListItemAnchor */.v0),
      _getOverrides4 = option_list_slicedToArray(_getOverrides3, 2),
      ListItemAnchor = _getOverrides4[0],
      listItemAnchorProps = _getOverrides4[1];

  var getItem = function getItem(item) {
    if (item.href && renderHrefAsAnchor) {
      return /*#__PURE__*/react.createElement(ListItemAnchor, option_list_extends({
        $item: item,
        href: item.href
      }, listItemAnchorProps), getItemLabel(item));
    } else {
      return /*#__PURE__*/react.createElement(react.Fragment, null, getItemLabel(item));
    }
  };

  return /*#__PURE__*/react.createElement(locale/* LocaleContext */.R.Consumer, null, function (locale) {
    return /*#__PURE__*/react.createElement(MaybeChildMenu, {
      getChildMenu: getChildMenu,
      isOpen: !!$isHighlighted,
      item: item,
      resetParentMenu: resetMenu,
      renderAll: renderAll,
      onClick: onClick,
      overrides: overrides
    }, /*#__PURE__*/react.createElement(ListItem, option_list_extends({
      ref: ref,
      "aria-label": getChildMenu && getChildMenu(item) ? locale.menu.parentMenuItemAriaLabel : null,
      item: item,
      onClick: onClick,
      onMouseEnter: onMouseEnter,
      $size: size,
      $isHighlighted: $isHighlighted
    }, restProps, listItemProps), getItem(_objectSpread({
      isHighlighted: $isHighlighted
    }, item))));
  });
}

function areEqualShallow(a, b) {
  if (!a || !b) return false;

  for (var key in a) {
    if (a[key] !== b[key]) {
      return false;
    }
  }

  return true;
}

function compare(prevProps, nextProps) {
  return prevProps.$isHighlighted === nextProps.$isHighlighted && prevProps.$isFocused === nextProps.$isFocused && areEqualShallow(prevProps.item, nextProps.item) && areEqualShallow(prevProps.overrides, nextProps.overrides) && prevProps.size === nextProps.size && prevProps.getItemLabel === nextProps.getItemLabel && prevProps.getChildMenu === nextProps.getChildMenu && prevProps.resetMenu === nextProps.resetMenu;
}

var forwarded = /*#__PURE__*/react.forwardRef(OptionList);
forwarded.displayName = 'OptionList';
/* harmony default export */ const option_list = (/*#__PURE__*/react.memo(forwarded, compare));
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/utils/focusVisible.js
var utils_focusVisible = __webpack_require__(27247);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/menu/menu.js
function menu_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = menu_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function menu_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function menu_extends() { menu_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return menu_extends.apply(this, arguments); }

function menu_slicedToArray(arr, i) { return menu_arrayWithHoles(arr) || menu_iterableToArrayLimit(arr, i) || menu_unsupportedIterableToArray(arr, i) || menu_nonIterableRest(); }

function menu_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function menu_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return menu_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return menu_arrayLikeToArray(o, minLen); }

function menu_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function menu_iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function menu_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

 // Components



 // Types


function Menu(props) {
  var _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      _props$ariaLabel = props.ariaLabel,
      ariaLabel = _props$ariaLabel === void 0 ? 'Menu' : _props$ariaLabel,
      _props$rootRef = props.rootRef,
      rootRef = _props$rootRef === void 0 ? /*#__PURE__*/react.createRef() : _props$rootRef,
      _props$focusMenu = props.focusMenu,
      focusMenu = _props$focusMenu === void 0 ? function () {} : _props$focusMenu,
      _props$unfocusMenu = props.unfocusMenu,
      unfocusMenu = _props$unfocusMenu === void 0 ? function () {} : _props$unfocusMenu,
      _props$handleMouseLea = props.handleMouseLeave,
      handleMouseLeave = _props$handleMouseLea === void 0 ? function () {} : _props$handleMouseLea,
      _props$handleKeyDown = props.handleKeyDown,
      handleKeyDown = _props$handleKeyDown === void 0 ? function (event) {} : _props$handleKeyDown,
      _props$renderAll = props.renderAll,
      renderAll = _props$renderAll === void 0 ? false : _props$renderAll;

  var _React$useState = react.useState(false),
      _React$useState2 = menu_slicedToArray(_React$useState, 2),
      focusVisible = _React$useState2[0],
      setFocusVisible = _React$useState2[1];

  var handleFocus = function handleFocus(event) {
    if ((0,utils_focusVisible/* isFocusVisible */.E)(event)) {
      setFocusVisible(true);
    }
  };

  var handleBlur = function handleBlur(event) {
    if (focusVisible !== false) {
      setFocusVisible(false);
    }
  };

  var _getOverrides = (0,helpers_overrides/* getOverrides */.jb)(overrides.List, styled_components/* StyledList */.CK),
      _getOverrides2 = menu_slicedToArray(_getOverrides, 2),
      List = _getOverrides2[0],
      listProps = _getOverrides2[1];

  var _getOverrides3 = (0,helpers_overrides/* getOverrides */.jb)(overrides.Option, option_list),
      _getOverrides4 = menu_slicedToArray(_getOverrides3, 2),
      Option = _getOverrides4[0],
      optionProps = _getOverrides4[1];

  var _getOverrides5 = (0,helpers_overrides/* getOverrides */.jb)(overrides.EmptyState, styled_components/* StyledEmptyState */.ey),
      _getOverrides6 = menu_slicedToArray(_getOverrides5, 2),
      EmptyState = _getOverrides6[0],
      emptyStateProps = _getOverrides6[1];

  var _getOverrides7 = (0,helpers_overrides/* getOverrides */.jb)(overrides.OptgroupHeader, styled_components/* StyledOptgroupHeader */.au),
      _getOverrides8 = menu_slicedToArray(_getOverrides7, 2),
      OptgroupHeader = _getOverrides8[0],
      optgroupHeaderProps = _getOverrides8[1];

  var groupedItems = Array.isArray(props.items) ? {
    __ungrouped: props.items
  } : props.items;
  var optgroups = Object.keys(groupedItems);

  var _optgroups$reduce = optgroups.reduce(function (_ref, optgroup) {
    var _ref2 = menu_slicedToArray(_ref, 2),
        els = _ref2[0],
        itemIndex = _ref2[1];

    if (optgroup !== '__ungrouped') {
      els.push( /*#__PURE__*/react.createElement(OptgroupHeader, menu_extends({
        key: optgroup
      }, optgroupHeaderProps), optgroup));
    }

    var groupItems = groupedItems[optgroup].map(function (item, index) {
      itemIndex = itemIndex + 1;
      var _props$getRequiredIte = props.getRequiredItemProps,
          getRequiredItemProps = _props$getRequiredIte === void 0 ? function (item, index) {
        return {};
      } : _props$getRequiredIte;

      var _getRequiredItemProps = getRequiredItemProps(item, itemIndex),
          disabled = _getRequiredItemProps.disabled,
          isFocused = _getRequiredItemProps.isFocused,
          isHighlighted = _getRequiredItemProps.isHighlighted,
          _getRequiredItemProps2 = _getRequiredItemProps.resetMenu,
          resetMenu = _getRequiredItemProps2 === void 0 ? function () {} : _getRequiredItemProps2,
          restProps = menu_objectWithoutProperties(_getRequiredItemProps, ["disabled", "isFocused", "isHighlighted", "resetMenu"]);

      return /*#__PURE__*/react.createElement(Option, menu_extends({
        renderAll: renderAll,
        key: itemIndex,
        item: item,
        overrides: props.overrides,
        resetMenu: resetMenu,
        role: "option",
        $disabled: disabled,
        $isFocused: isFocused,
        $isHighlighted: isHighlighted,
        "aria-disabled": disabled,
        "aria-selected": isHighlighted && isFocused
      }, restProps, optionProps));
    });
    return [els.concat(groupItems), itemIndex];
  }, [[], -1]),
      _optgroups$reduce2 = menu_slicedToArray(_optgroups$reduce, 1),
      elements = _optgroups$reduce2[0];

  var isEmpty = optgroups.every(function (optgroup) {
    return !groupedItems[optgroup].length;
  });
  return /*#__PURE__*/react.createElement(locale/* LocaleContext */.R.Consumer, null, function (locale) {
    return /*#__PURE__*/react.createElement(List, menu_extends({
      "aria-activedescendant": props.activedescendantId || null,
      role: "listbox",
      "aria-label": ariaLabel,
      ref: rootRef,
      onMouseEnter: focusMenu,
      onMouseLeave: handleMouseLeave,
      onMouseOver: focusMenu,
      onFocus: (0,utils_focusVisible/* forkFocus */.Ah)({
        onFocus: focusMenu
      }, handleFocus),
      onBlur: (0,utils_focusVisible/* forkBlur */.Z5)({
        onBlur: unfocusMenu
      }, handleBlur),
      onKeyDown: function onKeyDown(event) {
        if (props.isFocused) {
          handleKeyDown(event);
        }
      },
      tabIndex: 0,
      "data-baseweb": "menu",
      $isFocusVisible: focusVisible
    }, listProps), isEmpty ? /*#__PURE__*/react.createElement(EmptyState, menu_extends({
      "aria-live": "polite",
      "aria-atomic": true
    }, emptyStateProps), props.noResultsMsg || locale.menu.noResultsMsg) : elements);
  });
}
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/menu/utils.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

/* eslint-disable import/prefer-default-export */
// Helps scroll a list item into view when cycling through list via
// keybindings and highlighted item is not in view.
// Previously, this util had been using `scrollIntoView`. The issue with that method is that
// it will not only scroll the parent scroll but also the window scroll bar - causing a jump.
// problem description https://lists.w3.org/Archives/Public/www-style/2014Jul/0386.html
// CHASE: I've noticed some performance issues when testing this with many items in the list.
// I imagine the browser can debounce the `node.scrollIntoView` calls. Callers of this function
// will likely want to debounce themselves.
function scrollItemIntoView(child, parent, isFirst, isLast) {
  var scrollAlignInView = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'auto';
  if (!child) return;
  var childRect = child.getBoundingClientRect();
  var parentRect = parent.getBoundingClientRect(); // while scrolling down, if element is below view

  if (childRect.bottom > parentRect.bottom) {
    if (isLast) {
      parent.scrollTop = parent.scrollHeight - parentRect.height;
    } else {
      var targetBottom = child.offsetTop + childRect.height;
      parent.scrollTop = targetBottom - (scrollAlignInView === 'center' ? Math.round((parentRect.height + childRect.height) / 2) : parentRect.height);
    } // while scrolling up, if element is above view

  } else if (childRect.top < parentRect.top) {
    if (isFirst) {
      parent.scrollTop = 0;
    } else {
      parent.scrollTop = child.offsetTop - (scrollAlignInView === 'center' ? Math.round((parentRect.height - childRect.height) / 2) : 0);
    }
  }
}
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-uid@2.3.0_@types+react@17.0.4_react@0.0.0-experimental-4ead6b530/node_modules/react-uid/dist/es2015/hooks.js
var hooks = __webpack_require__(4689);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/menu/stateful-container.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function stateful_container_extends() { stateful_container_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return stateful_container_extends.apply(this, arguments); }

function stateful_container_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = stateful_container_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function stateful_container_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function stateful_container_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function stateful_container_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { stateful_container_ownKeys(Object(source), true).forEach(function (key) { stateful_container_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { stateful_container_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function stateful_container_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
 // Files


 // Types


var DEFAULT_PROPS = {
  // keeping it in defaultProps to satisfy Flow
  initialState: {
    // We start the index at -1 to indicate that no highlighting exists initially
    highlightedIndex: -1,
    isFocused: false
  },
  typeAhead: true,
  keyboardControlNode: {
    current: null
  },
  stateReducer: function (changeType, changes) {
    return changes;
  },
  onItemSelect: function onItemSelect() {},
  getRequiredItemProps: function getRequiredItemProps() {
    return {};
  },
  children: function children() {
    return null;
  },
  // from nested-menus context
  addMenuToNesting: function addMenuToNesting() {},
  removeMenuFromNesting: function removeMenuFromNesting() {},
  getParentMenu: function getParentMenu() {},
  getChildMenu: function getChildMenu() {},
  forceHighlight: false
};

var MenuStatefulContainerInner = /*#__PURE__*/function (_React$Component) {
  _inherits(MenuStatefulContainerInner, _React$Component);

  var _super = _createSuper(MenuStatefulContainerInner);

  function MenuStatefulContainerInner() {
    var _this;

    _classCallCheck(this, MenuStatefulContainerInner);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    stateful_container_defineProperty(_assertThisInitialized(_this), "state", stateful_container_objectSpread(stateful_container_objectSpread({}, _this.constructor.defaultProps.initialState), _this.props.initialState));

    stateful_container_defineProperty(_assertThisInitialized(_this), "rootRef", /*#__PURE__*/react.createRef());

    stateful_container_defineProperty(_assertThisInitialized(_this), "keyboardControlNode", _this.props.keyboardControlNode.current);

    stateful_container_defineProperty(_assertThisInitialized(_this), "refList", []);

    stateful_container_defineProperty(_assertThisInitialized(_this), "optionIds", []);

    stateful_container_defineProperty(_assertThisInitialized(_this), "typeAheadChars", '');

    stateful_container_defineProperty(_assertThisInitialized(_this), "typeAheadTimeOut", null);

    stateful_container_defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      switch (event.key) {
        case constants/* KEY_STRINGS */.YV.ArrowUp:
        case constants/* KEY_STRINGS */.YV.ArrowDown:
        case constants/* KEY_STRINGS */.YV.ArrowLeft:
        case constants/* KEY_STRINGS */.YV.ArrowRight:
        case constants/* KEY_STRINGS */.YV.Home:
        case constants/* KEY_STRINGS */.YV.End:
          _this.handleArrowKey(event);

          break;

        case constants/* KEY_STRINGS */.YV.Enter:
          if (event.keyCode === 229) {
            // ref.
            // https://github.com/JedWatson/react-select/blob/e12b42b0e7598ec4a96a1a6480e0b2b4c7dc03e3/packages/react-select/src/Select.js#L1209
            break;
          }

          _this.handleEnterKey(event);

          break;

        default:
          if (_this.props.typeAhead) {
            clearTimeout(_this.typeAheadTimeOut);

            _this.handleAlphaDown(event);
          }

          break;
      }
    });

    stateful_container_defineProperty(_assertThisInitialized(_this), "handleAlphaDown", function (event) {
      var rootRef = _this.props.rootRef ? _this.props.rootRef : _this.rootRef;
      var prevIndex = _this.state.highlightedIndex;
      _this.typeAheadChars += event.key;
      _this.typeAheadTimeOut = setTimeout(function () {
        _this.typeAheadChars = '';
      }, 500);
      var nextIndex = prevIndex;
      event.preventDefault();

      var list = _this.getItems();

      if (list.length === 0 || !('label' in list[0])) return;
      var notMatch = true;

      for (var n = 0; n < list.length; n++) {
        var label = list[n].label;

        if (label && label.toUpperCase && label.toUpperCase().indexOf(_this.typeAheadChars.toUpperCase()) === 0) {
          nextIndex = n;
          notMatch = false;
          break;
        }
      }

      if (notMatch) {
        for (var _n = 0; _n < list.length; _n++) {
          var _label = list[_n].label;

          if (_label && _label.toUpperCase && _label.toUpperCase().indexOf(_this.typeAheadChars.toUpperCase()) > 0) {
            nextIndex = _n;
            break;
          }
        }
      }

      _this.internalSetState(constants/* STATE_CHANGE_TYPES */.d0.character, {
        highlightedIndex: nextIndex
      });

      if (_this.refList[nextIndex]) {
        scrollItemIntoView(_this.refList[nextIndex].current, // $FlowFixMe
        rootRef.current, nextIndex === 0, nextIndex === list.length - 1);
      }
    });

    stateful_container_defineProperty(_assertThisInitialized(_this), "handleArrowKey", function (event) {
      var rootRef = _this.props.rootRef ? _this.props.rootRef : _this.rootRef;
      var prevIndex = _this.state.highlightedIndex;
      var nextIndex = prevIndex;

      if (event.key === constants/* KEY_STRINGS */.YV.ArrowUp) {
        event.preventDefault();
        nextIndex = Math.max(0, prevIndex - 1);

        _this.internalSetState(constants/* STATE_CHANGE_TYPES */.d0.moveUp, {
          highlightedIndex: nextIndex
        });
      } else if (event.key === constants/* KEY_STRINGS */.YV.ArrowDown) {
        event.preventDefault();
        nextIndex = Math.min(prevIndex + 1, _this.getItems().length - 1);

        _this.internalSetState(constants/* STATE_CHANGE_TYPES */.d0.moveDown, {
          highlightedIndex: nextIndex
        });
      } else if (event.key === constants/* KEY_STRINGS */.YV.Home) {
        event.preventDefault();
        nextIndex = 0;

        _this.internalSetState(constants/* STATE_CHANGE_TYPES */.d0.moveUp, {
          highlightedIndex: nextIndex
        });
      } else if (event.key === constants/* KEY_STRINGS */.YV.End) {
        event.preventDefault();
        nextIndex = _this.getItems().length - 1;

        _this.internalSetState(constants/* STATE_CHANGE_TYPES */.d0.moveDown, {
          highlightedIndex: nextIndex
        });
      } else if (event.key === constants/* KEY_STRINGS */.YV.ArrowLeft) {
        if (_this.props.getParentMenu) {
          var parent = _this.props.getParentMenu(rootRef);

          if (parent && parent.current) {
            parent.current.focus();
          }
        }
      } else if (event.key === constants/* KEY_STRINGS */.YV.ArrowRight) {
        if (_this.props.getChildMenu) {
          var child = _this.props.getChildMenu(rootRef);

          if (child && child.current) {
            child.current.focus();
          }
        }
      }

      if (_this.refList[nextIndex]) {
        scrollItemIntoView(_this.refList[nextIndex].current, // $FlowFixMe
        rootRef.current, nextIndex === 0, nextIndex === _this.getItems().length - 1);
      }
    });

    stateful_container_defineProperty(_assertThisInitialized(_this), "handleEnterKey", function (event) {
      var onItemSelect = _this.props.onItemSelect;
      var highlightedIndex = _this.state.highlightedIndex;

      var items = _this.getItems();

      if (items[highlightedIndex] && onItemSelect && !items[highlightedIndex].disabled) {
        event.preventDefault();
        onItemSelect({
          item: items[highlightedIndex],
          event: event
        });
      }
    });

    stateful_container_defineProperty(_assertThisInitialized(_this), "handleItemClick", function (index, item, event) {
      if (_this.props.onItemSelect && !item.disabled) {
        _this.props.onItemSelect({
          item: item,
          event: event
        });

        _this.internalSetState(constants/* STATE_CHANGE_TYPES */.d0.click, {
          highlightedIndex: index,
          activedescendantId: _this.optionIds[index]
        });
      }
    });

    stateful_container_defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function (index) {
      _this.internalSetState(constants/* STATE_CHANGE_TYPES */.d0.mouseEnter, {
        highlightedIndex: index,
        activedescendantId: _this.optionIds[index]
      });
    });

    stateful_container_defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function () {
      var rootRef = _this.props.rootRef ? _this.props.rootRef : _this.rootRef;

      var childMenu = _this.props.getChildMenu && _this.props.getChildMenu(rootRef);

      if (!_this.props.forceHighlight && !childMenu) {
        _this.internalSetState(constants/* STATE_CHANGE_TYPES */.d0.mouseLeave, {
          highlightedIndex: -1
        });
      }
    });

    stateful_container_defineProperty(_assertThisInitialized(_this), "getRequiredItemProps", function (item, index) {
      var itemRef = _this.refList[index];

      if (!itemRef) {
        itemRef = /*#__PURE__*/react.createRef();
        _this.refList[index] = itemRef;
        _this.optionIds[index] = _this.props.uidSeed(index);
      }

      var _this$props$getRequir = _this.props.getRequiredItemProps(item, index),
          disabledVal = _this$props$getRequir.disabled,
          requiredItemProps = stateful_container_objectWithoutProperties(_this$props$getRequir, ["disabled"]);

      var disabled = typeof disabledVal === 'boolean' ? disabledVal : !!item.disabled;
      return stateful_container_objectSpread(stateful_container_objectSpread({
        id: requiredItemProps.id || _this.optionIds[index],
        disabled: disabled,
        ref: itemRef,
        isFocused: _this.state.isFocused,
        isHighlighted: _this.state.highlightedIndex === index,
        resetMenu: _this.resetMenu
      }, disabled ? {} : {
        onClick: _this.handleItemClick.bind(_assertThisInitialized(_this), index, item),
        onMouseEnter: _this.handleMouseEnter.bind(_assertThisInitialized(_this), index)
      }), requiredItemProps);
    });

    stateful_container_defineProperty(_assertThisInitialized(_this), "focusMenu", function (event) {
      var rootRef = _this.props.rootRef ? _this.props.rootRef : _this.rootRef;

      if (!_this.state.isFocused && rootRef.current && // $FlowFixMe
      rootRef.current.contains(event.target)) {
        if (_this.state.highlightedIndex < 0) {
          _this.internalSetState(constants/* STATE_CHANGE_TYPES */.d0.focus, {
            isFocused: true,
            highlightedIndex: 0
          });
        } else {
          _this.internalSetState(constants/* STATE_CHANGE_TYPES */.d0.focus, {
            isFocused: true
          });
        }

        rootRef.current.focus();
      }
    });

    stateful_container_defineProperty(_assertThisInitialized(_this), "unfocusMenu", function () {
      _this.internalSetState(constants/* STATE_CHANGE_TYPES */.d0.focus, {
        isFocused: false
      });
    });

    stateful_container_defineProperty(_assertThisInitialized(_this), "resetMenu", function () {
      _this.internalSetState(constants/* STATE_CHANGE_TYPES */.d0.reset, {
        isFocused: false,
        highlightedIndex: -1,
        activedescendantId: null
      });
    });

    return _this;
  }

  _createClass(MenuStatefulContainerInner, [{
    key: "getItems",
    value: function getItems() {
      var _this2 = this;

      if (Array.isArray(this.props.items)) {
        return this.props.items;
      }

      var optgroups = Object.keys(this.props.items);
      return optgroups.reduce(function (output, optgroup) {
        // $FlowFixMe already checked above that items is grouped shape
        return output.concat(_this2.props.items[optgroup]);
      }, []);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var rootRef = this.props.rootRef ? this.props.rootRef : this.rootRef;

      if (typeof document !== 'undefined') {
        if (rootRef.current
        /** This condition added to satisfy Flow */
        && this.state.highlightedIndex > -1 && this.refList[this.state.highlightedIndex]) {
          scrollItemIntoView(this.refList[this.state.highlightedIndex].current, rootRef.current, this.state.highlightedIndex === 0, this.state.highlightedIndex === this.getItems().length - 1, 'center');
        }

        if (this.state.isFocused) {
          if (this.keyboardControlNode) {
            this.keyboardControlNode.addEventListener('keydown', this.onKeyDown);
          }
        }
      }

      this.props.addMenuToNesting && this.props.addMenuToNesting(rootRef);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var rootRef = this.props.rootRef ? this.props.rootRef : this.rootRef;

      if (typeof document !== 'undefined') {
        if (this.keyboardControlNode) this.keyboardControlNode.removeEventListener('keydown', this.onKeyDown);
      }

      this.props.removeMenuFromNesting && this.props.removeMenuFromNesting(rootRef);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_, prevState) {
      if (typeof document !== 'undefined') {
        if (!prevState.isFocused && this.state.isFocused) {
          if (this.keyboardControlNode) this.keyboardControlNode.addEventListener('keydown', this.onKeyDown);
        } else if (prevState.isFocused && !this.state.isFocused) {
          if (this.keyboardControlNode) this.keyboardControlNode.removeEventListener('keydown', this.onKeyDown);
        }
      }

      var range = this.getItems().length;

      if (this.props.forceHighlight && this.state.highlightedIndex === -1 && range > 0) {
        this.internalSetState(constants/* STATE_CHANGE_TYPES */.d0.enter, {
          highlightedIndex: 0
        });
      }

      if (range === 0 && this.state.highlightedIndex !== -1) {
        this.internalSetState(constants/* STATE_CHANGE_TYPES */.d0.enter, {
          highlightedIndex: -1
        });
      } else if (this.state.highlightedIndex >= range) {
        this.internalSetState(constants/* STATE_CHANGE_TYPES */.d0.enter, {
          highlightedIndex: 0
        });
      }
    } // One array to hold all of list item refs

  }, {
    key: "internalSetState",
    value: // Internal set state function that will also invoke stateReducer
    function internalSetState(changeType, changes) {
      var stateReducer = this.props.stateReducer;

      if (this.props.onActiveDescendantChange && typeof changes.highlightedIndex === 'number' && this.state.highlightedIndex !== changes.highlightedIndex) {
        this.props.onActiveDescendantChange(this.optionIds[changes.highlightedIndex]);
      }

      this.setState(stateReducer(changeType, changes, this.state));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      // omit the stateful-container's props and don't pass it down
      // to the children (stateless menu)
      var _this$props = this.props,
          initialState = _this$props.initialState,
          stateReducer = _this$props.stateReducer,
          children = _this$props.children,
          onItemSelect = _this$props.onItemSelect,
          addMenuToNesting = _this$props.addMenuToNesting,
          removeMenuFromNesting = _this$props.removeMenuFromNesting,
          getParentMenu = _this$props.getParentMenu,
          getChildMenu = _this$props.getChildMenu,
          forceHighlight = _this$props.forceHighlight,
          restProps = stateful_container_objectWithoutProperties(_this$props, ["initialState", "stateReducer", "children", "onItemSelect", "addMenuToNesting", "removeMenuFromNesting", "getParentMenu", "getChildMenu", "forceHighlight"]);

      return this.props.children(stateful_container_objectSpread(stateful_container_objectSpread({}, restProps), {}, {
        rootRef: this.props.rootRef ? this.props.rootRef : this.rootRef,
        activedescendantId: this.optionIds[this.state.highlightedIndex],
        getRequiredItemProps: function getRequiredItemProps(item, index) {
          return _this3.getRequiredItemProps(item, index);
        },
        handleMouseLeave: this.handleMouseLeave,
        highlightedIndex: this.state.highlightedIndex,
        isFocused: this.state.isFocused,
        handleKeyDown: this.props.keyboardControlNode.current ? function (event) {} : this.onKeyDown,
        focusMenu: this.focusMenu,
        unfocusMenu: this.unfocusMenu
      }));
    }
  }]);

  return MenuStatefulContainerInner;
}(react.Component); // Remove when MenuStatefulContainer is converted to a functional component.


stateful_container_defineProperty(MenuStatefulContainerInner, "defaultProps", DEFAULT_PROPS);

var MenuStatefulContainer = function MenuStatefulContainer(props) {
  return /*#__PURE__*/react.createElement(MenuStatefulContainerInner, stateful_container_extends({
    uidSeed: (0,hooks/* useUIDSeed */.H)()
  }, props));
};

MenuStatefulContainer.defaultProps = DEFAULT_PROPS;
/* harmony default export */ const stateful_container = (MenuStatefulContainer);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/menu/stateful-menu.js
function stateful_menu_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { stateful_menu_typeof = function _typeof(obj) { return typeof obj; }; } else { stateful_menu_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return stateful_menu_typeof(obj); }

function stateful_menu_extends() { stateful_menu_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return stateful_menu_extends.apply(this, arguments); }

function stateful_menu_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = stateful_menu_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function stateful_menu_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function stateful_menu_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function stateful_menu_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function stateful_menu_createClass(Constructor, protoProps, staticProps) { if (protoProps) stateful_menu_defineProperties(Constructor.prototype, protoProps); if (staticProps) stateful_menu_defineProperties(Constructor, staticProps); return Constructor; }

function stateful_menu_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) stateful_menu_setPrototypeOf(subClass, superClass); }

function stateful_menu_setPrototypeOf(o, p) { stateful_menu_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return stateful_menu_setPrototypeOf(o, p); }

function stateful_menu_createSuper(Derived) { var hasNativeReflectConstruct = stateful_menu_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = stateful_menu_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = stateful_menu_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return stateful_menu_possibleConstructorReturn(this, result); }; }

function stateful_menu_possibleConstructorReturn(self, call) { if (call && (stateful_menu_typeof(call) === "object" || typeof call === "function")) { return call; } return stateful_menu_assertThisInitialized(self); }

function stateful_menu_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function stateful_menu_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function stateful_menu_getPrototypeOf(o) { stateful_menu_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return stateful_menu_getPrototypeOf(o); }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

/* eslint-disable react/prefer-stateless-function */





var StatefulMenu = /*#__PURE__*/function (_React$PureComponent) {
  stateful_menu_inherits(StatefulMenu, _React$PureComponent);

  var _super = stateful_menu_createSuper(StatefulMenu);

  function StatefulMenu() {
    stateful_menu_classCallCheck(this, StatefulMenu);

    return _super.apply(this, arguments);
  }

  stateful_menu_createClass(StatefulMenu, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          overrides = _this$props.overrides,
          props = stateful_menu_objectWithoutProperties(_this$props, ["overrides"]);

      return /*#__PURE__*/react.createElement(nested_menus/* NestedMenuContext */.$.Consumer, null, function (ctx) {
        return /*#__PURE__*/react.createElement(stateful_container, stateful_menu_extends({}, ctx, props), function (renderProps) {
          return /*#__PURE__*/react.createElement(Menu, stateful_menu_extends({}, renderProps, {
            overrides: overrides
          }));
        });
      });
    }
  }]);

  return StatefulMenu;
}(react.PureComponent);



/***/ }),

/***/ 81833:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CK: () => (/* binding */ StyledList),
/* harmony export */   au: () => (/* binding */ StyledOptgroupHeader),
/* harmony export */   ey: () => (/* binding */ StyledEmptyState),
/* harmony export */   oH: () => (/* binding */ StyledListItem),
/* harmony export */   v0: () => (/* binding */ StyledListItemAnchor)
/* harmony export */ });
/* unused harmony exports StyledListItemElement, StyledListItemProfile, StyledProfileImgContainer, StyledProfileImg, StyledProfileLabelsContainer, StyledProfileTitle, StyledProfileSubtitle, StyledProfileBody */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);
/* harmony import */ var _styles_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10334);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40261);
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/



var StyledList = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)('ul', function (_ref) {
  var $theme = _ref.$theme,
      $isFocusVisible = _ref.$isFocusVisible;
  return {
    backgroundColor: $theme.colors.menuFill,
    position: 'relative',
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    paddingTop: $theme.sizing.scale300,
    paddingBottom: $theme.sizing.scale300,
    paddingLeft: 0,
    paddingRight: 0,
    borderTopLeftRadius: $theme.borders.popoverBorderRadius,
    borderTopRightRadius: $theme.borders.popoverBorderRadius,
    borderBottomRightRadius: $theme.borders.popoverBorderRadius,
    borderBottomLeftRadius: $theme.borders.popoverBorderRadius,
    boxShadow: $theme.lighting.shadow600,
    overflow: 'auto',
    ':focus': {
      outline: $isFocusVisible ? "3px solid ".concat($theme.colors.accent) : 'none'
    }
  };
});
StyledList.displayName = "StyledList";

function getFontColor(props) {
  if (props.$disabled) {
    return props.$theme.colors.menuFontDisabled;
  }

  if (props.$isHighlighted && props.$isFocused) {
    return props.$theme.colors.menuFontHighlighted;
  }

  if (props.$isHighlighted && !props.$isFocused) {
    return props.$theme.colors.menuFontSelected;
  }

  return props.$theme.colors.menuFontDefault;
}

function getBackgroundColor(props) {
  if (props.$disabled) {
    return 'transparent';
  }

  if (props.$isHighlighted) {
    return props.$theme.colors.menuFillHover;
  }

  return 'transparent';
}

var StyledEmptyState = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)('li', function (props) {
  var $theme = props.$theme,
      $size = props.$size;
  return _objectSpread(_objectSpread({}, $size === _constants_js__WEBPACK_IMPORTED_MODULE_2__/* .OPTION_LIST_SIZE */ .Sz.compact ? $theme.typography.font100 : $theme.typography.font200), {}, {
    position: 'relative',
    display: 'block',
    color: $theme.colors.menuFontDisabled,
    textAlign: 'center',
    cursor: 'not-allowed',
    backgroundColor: 'transparent',
    marginBottom: 0,
    paddingTop: $theme.sizing.scale800,
    paddingBottom: $theme.sizing.scale800,
    paddingRight: $theme.sizing.scale800,
    paddingLeft: $theme.sizing.scale800
  });
});
StyledEmptyState.displayName = "StyledEmptyState";
var StyledOptgroupHeader = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)('li', function (props) {
  var paddingX = props.$theme.sizing.scale300;
  var paddingY = props.$theme.sizing.scale200;
  return _objectSpread(_objectSpread({}, props.$theme.typography.font250), {}, {
    color: props.$theme.colors.colorPrimary,
    paddingTop: paddingY,
    paddingBottom: paddingY,
    paddingRight: paddingX,
    paddingLeft: paddingX
  });
});
StyledOptgroupHeader.displayName = "StyledOptgroupHeader";
var StyledListItemAnchor = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)('a', function (props) {
  return {
    display: 'block',
    color: getFontColor(props)
  };
});
StyledListItemAnchor.displayName = "StyledListItemAnchor";
var StyledListItemElement = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)('li', function (props) {
  var $disabled = props.$disabled,
      $theme = props.$theme,
      $size = props.$size;
  return _objectSpread(_objectSpread({}, $size === _constants_js__WEBPACK_IMPORTED_MODULE_2__/* .OPTION_LIST_SIZE */ .Sz.compact ? $theme.typography.font100 : $theme.typography.font200), {}, {
    position: 'relative',
    display: 'block',
    color: getFontColor(props),
    cursor: $disabled ? 'not-allowed' : 'pointer',
    backgroundColor: getBackgroundColor(props),
    transitionProperty: 'color, background-color',
    transitionDuration: $theme.animation.timing200,
    transitionTimingFunction: $theme.animation.easeOutCurve,
    marginBottom: 0,
    paddingTop: $size === _constants_js__WEBPACK_IMPORTED_MODULE_2__/* .OPTION_LIST_SIZE */ .Sz.compact ? $theme.sizing.scale100 : $theme.sizing.scale300,
    paddingBottom: $size === _constants_js__WEBPACK_IMPORTED_MODULE_2__/* .OPTION_LIST_SIZE */ .Sz.compact ? $theme.sizing.scale100 : $theme.sizing.scale300,
    paddingRight: $size === _constants_js__WEBPACK_IMPORTED_MODULE_2__/* .OPTION_LIST_SIZE */ .Sz.compact ? $theme.sizing.scale900 : $theme.sizing.scale600,
    paddingLeft: $size === _constants_js__WEBPACK_IMPORTED_MODULE_2__/* .OPTION_LIST_SIZE */ .Sz.compact ? $theme.sizing.scale900 : $theme.sizing.scale600,
    ':focus': {
      outline: 'none'
    }
  });
});
StyledListItemElement.displayName = "StyledListItemElement";
var StyledListItem = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_1__/* .withWrapper */ .Le)(StyledListItemElement, function (Styled) {
  return function StyledListItem(_ref2) {
    var item = _ref2.item,
        restProps = _objectWithoutProperties(_ref2, ["item"]);

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Styled, restProps);
  };
});
var StyledListItemProfile = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)('li', function (_ref3) {
  var $theme = _ref3.$theme;
  return {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    paddingTop: $theme.sizing.scale300,
    paddingBottom: $theme.sizing.scale300,
    paddingRight: $theme.sizing.scale800,
    paddingLeft: $theme.sizing.scale800,
    transitionProperty: 'color, background-color',
    transitionDuration: $theme.animation.timing200,
    transitionTimingFunction: $theme.animation.easeOutCurve,
    ':hover': {
      backgroundColor: $theme.colors.menuFillHover
    }
  };
});
StyledListItemProfile.displayName = "StyledListItemProfile";
var StyledProfileImgContainer = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)('div', {
  width: '60px',
  height: '60px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});
StyledProfileImgContainer.displayName = "StyledProfileImgContainer";
var StyledProfileImg = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)('img', {
  width: '100%',
  height: '100%',
  borderTopLeftRadius: '50%',
  borderTopRightRadius: '50%',
  borderBottomRightRadius: '50%',
  borderBottomLeftRadius: '50%'
});
StyledProfileImg.displayName = "StyledProfileImg";
var StyledProfileLabelsContainer = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)('div', function (_ref4) {
  var _ref4$$theme = _ref4.$theme,
      direction = _ref4$$theme.direction,
      sizing = _ref4$$theme.sizing;
  return _objectSpread({
    alignSelf: direction === 'rtl' ? 'flex-end' : 'flex-start',
    display: 'flex',
    flexDirection: 'column'
  }, direction === 'rtl' ? {
    marginRight: sizing.scale600
  } : {
    marginLeft: sizing.scale600
  });
});
StyledProfileLabelsContainer.displayName = "StyledProfileLabelsContainer";
var StyledProfileTitle = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)('h6', function (_ref5) {
  var $theme = _ref5.$theme;
  return _objectSpread(_objectSpread({}, $theme.typography.font350), {}, {
    color: $theme.colors.contentPrimary,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0
  });
});
StyledProfileTitle.displayName = "StyledProfileTitle";
var StyledProfileSubtitle = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)('p', function (_ref6) {
  var $theme = _ref6.$theme;
  return _objectSpread(_objectSpread({}, $theme.typography.font200), {}, {
    color: $theme.colors.contentPrimary,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0
  });
});
StyledProfileSubtitle.displayName = "StyledProfileSubtitle";
var StyledProfileBody = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)('p', function (_ref7) {
  var $theme = _ref7.$theme;
  return _objectSpread(_objectSpread({}, $theme.typography.font100), {}, {
    color: $theme.colors.contentPrimary,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0
  });
});
StyledProfileBody.displayName = "StyledProfileBody";

/***/ }),

/***/ 57222:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   N: () => (/* binding */ SIZE)
/* harmony export */ });
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var SIZE = {
  small: 'small',
  medium: 'medium',
  large: 'large'
};

/***/ }),

/***/ 60674:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   aN: () => (/* binding */ StyledSpinnerNext),
/* harmony export */   dw: () => (/* binding */ StyledTrackPath),
/* harmony export */   l1: () => (/* binding */ StyledActivePath),
/* harmony export */   ny: () => (/* binding */ Svg)
/* harmony export */ });
/* harmony import */ var _styles_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10334);
/* harmony import */ var _icon_styled_components_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74995);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57222);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/



var spin = {
  from: {
    transform: 'rotate(0deg)'
  },
  to: {
    transform: 'rotate(360deg)'
  }
};
/**
 * Spinner icon overrides
 */

var Svg = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)('svg', function (props) {
  var $theme = props.$theme,
      $color = props.$color;
  return _objectSpread(_objectSpread({}, (0,_icon_styled_components_js__WEBPACK_IMPORTED_MODULE_1__/* .getSvgStyles */ .u)(props)), {}, {
    fill: $color || $theme.colors.accent,
    cursor: 'wait',
    animationName: spin,
    animationDuration: $theme.animation.timing1000,
    animationIterationCount: 'infinite',
    animationTimingFunction: 'linear'
  });
});
Svg.displayName = "Svg";
var StyledTrackPath = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)('path', function (props) {
  return {
    fill: props.$theme.colors.spinnerTrackFill,
    opacity: 0.16
  };
});
StyledTrackPath.displayName = "StyledTrackPath";
var StyledActivePath = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)('path', function (props) {
  return {
    fill: props.$color || props.$theme.colors.accent
  };
}); // TODO(v11): Replace Spinner with SpinnerNext

StyledActivePath.displayName = "StyledActivePath";
var StyledSpinnerNext = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)('div', function (_ref) {
  var $theme = _ref.$theme,
      _ref$$size = _ref.$size,
      $size = _ref$$size === void 0 ? _constants_js__WEBPACK_IMPORTED_MODULE_2__/* .SIZE */ .N.medium : _ref$$size;
  var borderWidth = {
    large: $theme.sizing.scale300,
    medium: $theme.sizing.scale100,
    small: $theme.sizing.scale0
  }[$size];
  return {
    display: 'block',
    animationName: spin,
    animationDuration: $theme.animation.timing1000,
    animationIterationCount: 'infinite',
    animationTimingFunction: 'linear',
    borderLeftStyle: 'solid',
    borderRightStyle: 'solid',
    borderTopStyle: 'solid',
    borderBottomStyle: 'solid',
    borderRadius: '50%',
    borderTopColor: $theme.colors.contentAccent,
    borderRightColor: $theme.colors.backgroundTertiary,
    borderBottomColor: $theme.colors.backgroundTertiary,
    borderLeftColor: $theme.colors.backgroundTertiary,
    borderLeftWidth: borderWidth,
    borderRightWidth: borderWidth,
    borderTopWidth: borderWidth,
    borderBottomWidth: borderWidth,
    width: {
      large: $theme.sizing.scale1000,
      medium: $theme.sizing.scale900,
      small: $theme.sizing.scale800
    }[$size],
    height: {
      large: $theme.sizing.scale1000,
      medium: $theme.sizing.scale900,
      small: $theme.sizing.scale800
    }[$size],
    cursor: 'wait'
  };
});
StyledSpinnerNext.displayName = "StyledSpinnerNext";

/***/ })

}]);